import { render, staticRenderFns } from "./ownList.vue?vue&type=template&id=5c4d5678&scoped=true&"
import script from "./ownList.vue?vue&type=script&lang=js&"
export * from "./ownList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4d5678",
  null
  
)

export default component.exports